import { getAuthClient } from "@acme/auth/src/auth.client";

export const authClient = getAuthClient({
  baseURL: process.env.NEXT_PUBLIC_APP_URL,
});

export const { signIn, signOut, signUp, useSession, requestPasswordReset } =
  authClient;
